import type { RootState } from '../store';
import type { Order } from './orderModels';

// Select current order
export const selectCurrentOrder = (state: RootState) => 
  state.orders.currentOrder;

// Select order history
export const selectOrderHistory = (state: RootState) => 
  state.orders.orderHistory;

// Select loading state
export const selectOrdersLoading = (state: RootState) => 
  state.orders.loading;

// Select error state
export const selectOrdersError = (state: RootState) => 
  state.orders.error;

// Select status
export const selectOrdersStatus = (state: RootState) => 
  state.orders.status;

// Select success message
export const selectOrdersSuccessMessage = (state: RootState) => 
  state.orders.successMessage;

// Select total orders count
export const selectTotalOrders = (state: RootState) => 
  state.orders.orderHistory.length;

// Select total spent (sum of all order amounts)
export const selectTotalSpent = (state: RootState) => {
  return state.orders.orderHistory.reduce(
    (total: number, order: Order) => total + parseFloat(order.totalPrice || '0'),
    0
  );
};

// Select orders by status
export const selectOrdersByStatus = (status: string) => (state: RootState) => {
  return state.orders.orderHistory.filter((order: Order) => order.status === status);
};

// Select most recent order
export const selectMostRecentOrder = (state: RootState) => {
  if (state.orders.orderHistory.length === 0) return null;
  return state.orders.orderHistory[state.orders.orderHistory.length - 1];
};

